import { z } from "zod";
import { Timestamps } from "../../common/index.ts";
import { EntityId, EntityTypeId, CustomerId } from "../fsm.schema.ts";

/**
 * @description An Entity represents a specific user, role, profile or system that can be responsible for executing transitions in the FSM.
 */
export const EntityDto = z
  .object({
    id: EntityId,
    customerId: CustomerId,
    name: z.string().min(1),
    entityTypeId: EntityTypeId,
  })
  .merge(Timestamps);

export type EntityDto = z.infer<typeof EntityDto>;

export const CreateEntityInput = z.object({
  name: z.string().min(1),
  entityTypeId: EntityTypeId,
});
export type CreateEntityInput = z.infer<typeof CreateEntityInput>;

export const UpdateEntityInput = z.object({
  name: z.string().min(1).optional(),
  entityTypeId: EntityTypeId.optional(),
});
export type UpdateEntityInput = z.infer<typeof UpdateEntityInput>;
